module.exports = __webpack_public_path__ + "static/media/default-img.677228d1.jpg";